import { EditRoot, Root } from "./root";
import {
  Body,
  Content,
  Description,
  Header,
  Properties,
  Stat,
  Stats,
  StatusBadge,
  StatusPicker,
  Title,
  Toolbar,
  WhenEditing,
  WhenReading,
} from "./slots";
import { NotFound, Pending } from "./states";

/**
 * The chrome every catalog definition page shares, read and edit alike.
 *
 * A compound component rather than a config registry on purpose: eight small
 * trees that each say what they render beat one generic page that grows an
 * optional field per exception. See the plan's Non-goals.
 */
export const CatalogDefinition = {
  Root,
  EditRoot,
  Toolbar,
  Header,
  Title,
  Description,
  Properties,
  StatusBadge,
  StatusPicker,
  Body,
  Stats,
  Stat,
  Content,
  WhenReading,
  WhenEditing,
  Pending,
  NotFound,
};

export {
  type CatalogDefinitionContextValue,
  type DefinitionShell,
  type DefinitionStatus,
  statusLabel,
  toDefinitionStatus,
  useCatalogDefinition,
} from "./catalog-definition-context";
export {
  type ShellFieldName,
  type ShellForm,
  type ShellFormValues,
  useDefinitionDirty,
  useShellDirty,
  useShellForm,
} from "./use-shell-form";
